import { Button, Icon } from "@shared/components";
import cn from "classnames";
import React from "react";

interface IProps {
  onClick: () => void;
  isActive: boolean;
  iconProps?: {
    variant?: "heart";
    size: number;
    rotate: number;
    scaleX: boolean;
    scaleY: boolean;
  };
}

export const FavoriteButton: React.FC<IProps> = ({
  isActive,
  onClick,
  iconProps,
}) => {
  const [isFavoriteClassActive, setFavoriteClassActive] = React.useState(false);

  const handleClick = () => {
    setFavoriteClassActive(!isFavoriteClassActive);
    onClick();
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const ButtonComponent = Button as React.FC<any>;
  return (
    <ButtonComponent
      variant="icon"
      className="button-star button-icon"
      onClick={handleClick}
    >
      <Icon
        {...iconProps}
        name={"heart"}
        className={cn("button-star__star", {
          "button-star--inactive": !isActive,
        })}
        activeClass={cn({
          "button-star--active": isFavoriteClassActive && isActive,
          "button-star--static-active": isActive,
        })}
        isActive={isActive}
      />
    </ButtonComponent>
  );
};
